import { render, staticRenderFns } from "./comtable.vue?vue&type=template&id=56c121a5&scoped=true"
import script from "./comtable.vue?vue&type=script&lang=js"
export * from "./comtable.vue?vue&type=script&lang=js"
import style0 from "./comtable.vue?vue&type=style&index=0&id=56c121a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c121a5",
  null
  
)

export default component.exports